<template>
  <div style='height: 100%'>
    <!-- 工具栏 -->
    <div class='navbar'>
      <el-button type='primary' icon='sys sys-refresh' class='navbarbtn'
        @click='refreshMainTableContent'>
        刷 新
      </el-button>

      <el-button type='primary' icon='sys sys-add' class='navbarbtn' v-if='showAddPower'
        @click='showAddMenuDialogMD(1)'>
        新 增
      </el-button>

      <el-button type='primary' icon='sys sys-expand' class='navbarbtn'
        @click='expandRow'>
        展 开
      </el-button>

      <el-button type='primary' icon='sys sys-narrow' class='navbarbtn'
        @click='narrowRow'>
        收 起
      </el-button>
    </div>

    <el-table :data='menus' :cell-style='mainTableCellStyle' :header-cell-style='mainTableHeaderCellStyle'
      v-loading='loading' row-key='GUID' border :height='getTableHeight()'
      :row-style='mainTableRowStyle' ref='mainTable'
      :tree-props='{ children: "children" }' :expand-row-keys='expandRowKeys'>
      <el-table-column prop='Seq' label='序号' width='100' fixed>
      </el-table-column>
      <el-table-column prop='MenuCode' label='菜单编号' width='260' fixed show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop='MenuName' label='菜单名称' width='160' fixed show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop='FilePath' label='文件路径' width='260' show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop='Icon' label='图标' width='250' show-overflow-tooltip>
        <template #default='scope'>
          <i :class='scope.row.Icon'></i>
          {{scope.row.Icon}}
        </template>
      </el-table-column>
      <el-table-column prop='Description' label='描述' width='200' show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop='Parameter' label='参数' width='200' show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop='CreateTime' label='创建时间' width='170'>
      </el-table-column>
      <el-table-column prop='CreateUserName' label='创建人' width='100'>
      </el-table-column>
      <el-table-column prop='UpdateTime' label='更新时间' width='170'>
      </el-table-column>
      <el-table-column prop='UpdateUserName' label='更新人' width='100'>
      </el-table-column>
      <el-table-column label='操作' width='120' fixed='right'>
        <template #default='scope'>
          <el-button type='primary' circle style='padding: 4px;' @click='showAddMenuDialogMD(scope.row.MenuLevel + 1, scope.row.MenuCode)'
            v-if='scope.row.IsLeaf === "0" && scope.row.MenuLevel !== 999 && showAddPower'><i class='sys sys-add'></i>
          </el-button>
          <el-button type='success' circle style='padding: 4px;' @click='showPowerTableEditorDialogMD(scope.row)'
            v-if='scope.row.IsLeaf === "1" && scope.row.MenuLevel !== 999'><i class='sys sys-power'></i>
          </el-button>
          <el-button type='primary' circle style='padding: 4px;' @click='showEditMenuDialogMD(scope.row)'
            v-if='scope.row.MenuLevel !== 999 && showEditPower'><i class='sys sys-edit'></i>
          </el-button>
          <el-button type='danger' circle style='padding: 4px;' @click='showDeleteOneMenuConfirm(scope)'
            v-if='scope.row.MenuLevel !== 999 && showDeletePower'><i class='sys sys-delete'></i>
          </el-button>
          <el-button type='primary' circle style='padding: 4px;' @click='showPowerTableEditorDialogEditMD(scope)'
            v-if='scope.row.MenuLevel === 999'><i class='sys sys-edit'></i>
          </el-button>
          <el-button type='danger' circle style='padding: 4px;' @click='deleteOnePowerTableEditor(scope)'
            v-if='scope.row.MenuLevel === 999'><i class='sys sys-delete'></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增菜单弹出框 -->
    <el-dialog v-dialogDrag title='添加菜单' :visible.sync='showAddMenuDialog' width='600px' top='10px' lock-scroll>
      <el-form :model='addMenuInfo' label-width='80px' style='margin-top: -20px;'
        label-position='right' size='mini'>
        <div class='hbox'>
          <el-form-item label='菜单编号 ' prop='menuCode' class='formRow mustIn'>
            <el-input v-model='addMenuInfo.menuCode' placeholder='必填' style='width: 200px;'></el-input>
          </el-form-item>

          <el-form-item label='菜单名称 ' prop='menuName' class='formRow mustIn'>
            <el-input v-model='addMenuInfo.menuName' placeholder='必填' style='width: 200px;'></el-input>
          </el-form-item>
        </div>

        <div class='hbox'>
          <el-form-item label='菜单描述 ' prop='description' class='formRow'>
            <el-input v-model='addMenuInfo.description' placeholder='请输入' style='width: 480px;'></el-input>
          </el-form-item>
        </div>

        <div class='hbox'>
          <el-form-item label='菜单序号 ' prop='seq' class='formRow mustIn'>
            <el-input-number v-model='addMenuInfo.seq' placeholder='必填' style='width: 200px;'></el-input-number>
          </el-form-item>

          <el-form-item label='图标 ' prop='icon' class='formRow'>
            <el-input v-model='addMenuInfo.icon' placeholder='请输入' style='width: 200px;'></el-input>
          </el-form-item>
        </div>

        <div class='hbox'>
          <el-form-item label='是否叶子 ' prop='isLeaf' class='formRow mustIn'>
            <el-select v-model='addMenuInfo.isLeaf' placeholder='请选择'
              style='width:200px;' size='mini'>
              <el-option v-for='isLeaf in isLeafs' :key='isLeaf.code' :label='isLeaf.name' :value='isLeaf.code'>
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label='超管专用 ' prop='superAdminOnlyMenu' class='formRow mustIn'>
            <el-select v-model='addMenuInfo.superAdminOnlyMenu' placeholder='请选择'
              style='width:200px;' size='mini'>
              <el-option v-for='superAdminOnlyMenu in superAdminOnlyMenus' :key='superAdminOnlyMenu.code' :label='superAdminOnlyMenu.name' :value='superAdminOnlyMenu.code'>
              </el-option>
            </el-select>
          </el-form-item>
        </div>

        <div class='hbox'>
          <el-form-item label='文件路径 ' prop='filePath' class='formRow'>
            <el-input v-model='addMenuInfo.filePath' placeholder='请输入' style='width: 480px;'></el-input>
          </el-form-item>
        </div>

        <div class='hbox'>
          <el-form-item label='参数 ' prop='parameter' class='formRow'>
            <el-input v-model='addMenuInfo.parameter' placeholder='请输入' style='width: 480px;'></el-input>
          </el-form-item>
        </div>

        <div class='dialogButtomBtn'>
          <el-button type='primary' @click='addMenu()' size='mini'>保存</el-button>
          <el-button @click='addMenuInfoReset(1)' size='mini'>重置</el-button>
        </div>
      </el-form>
    </el-dialog>

    <!-- 修改菜单弹出框 -->
    <el-dialog v-dialogDrag title='编辑菜单' :visible.sync='showEditMenuDialog' width='600px' top='10px' lock-scroll>
      <el-form :model='editMenuInfo' label-width='80px' style='margin-top: -20px;'
        label-position='right' size='mini'>
        <div class='hbox'>
          <el-form-item label='菜单编号 ' prop='menuCode' class='formRow mustIn'>
            <el-input v-model='editMenuInfo.menuCode' placeholder='必填' style='width: 200px;' disabled></el-input>
          </el-form-item>

          <el-form-item label='菜单名称 ' prop='menuName' class='formRow mustIn'>
            <el-input v-model='editMenuInfo.menuName' placeholder='必填' style='width: 200px;'></el-input>
          </el-form-item>
        </div>

        <div class='hbox'>
          <el-form-item label='菜单描述 ' prop='description' class='formRow'>
            <el-input v-model='editMenuInfo.description' placeholder='请输入' style='width: 480px;'></el-input>
          </el-form-item>
        </div>

        <div class='hbox'>
          <el-form-item label='菜单序号 ' prop='seq' class='formRow mustIn'>
            <el-input-number v-model='editMenuInfo.seq' placeholder='必填' style='width: 200px;'></el-input-number>
          </el-form-item>

          <el-form-item label='图标 ' prop='icon' class='formRow'>
            <el-input v-model='editMenuInfo.icon' placeholder='请输入' style='width: 200px;'></el-input>
          </el-form-item>
        </div>

        <div class='hbox'>
          <el-form-item label='是否叶子 ' prop='isLeaf' class='formRow mustIn'>
            <el-select v-model='editMenuInfo.isLeaf' placeholder='请选择' disabled
              style='width:200px;' size='mini'>
              <el-option v-for='isLeaf in isLeafs' :key='isLeaf.code' :label='isLeaf.name' :value='isLeaf.code'>
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label='超管专用 ' prop='superAdminOnlyMenu' class='formRow mustIn'>
            <el-select v-model='editMenuInfo.superAdminOnlyMenu' placeholder='请选择'
              style='width:200px;' size='mini'>
              <el-option v-for='superAdminOnlyMenu in superAdminOnlyMenus' :key='superAdminOnlyMenu.code' :label='superAdminOnlyMenu.name' :value='superAdminOnlyMenu.code'>
              </el-option>
            </el-select>
          </el-form-item>
        </div>

        <div class='hbox'>
          <el-form-item label='文件路径 ' prop='filePath' class='formRow'>
            <el-input v-model='editMenuInfo.filePath' placeholder='请输入' style='width: 480px;'></el-input>
          </el-form-item>
        </div>

        <div class='hbox'>
          <el-form-item label='参数 ' prop='parameter' class='formRow'>
            <el-input v-model='editMenuInfo.parameter' placeholder='请输入' style='width: 480px;'></el-input>
          </el-form-item>
        </div>

        <div class='dialogButtomBtn'>
          <el-button type='primary' @click='editMenu()' size='mini'>保存</el-button>
          <el-button @click='editMenuInfoReset(1)' size='mini'>重置</el-button>
        </div>
      </el-form>
    </el-dialog>

    <el-dialog v-dialogDrag :title='powerTableEditor.editFlag ? "变更" + powerTableEditor.tableEditorInfo.TableEditorName : "添加" + powerTableEditor.tableEditorInfo.TableEditorName'
      :visible.sync='showPowerTableEditorDialog'
      :width='(powerTableEditor.editFlag ? powerTableEditor.tableEditorInfo.EditWidth + 40 : powerTableEditor.tableEditorInfo.SaveWidth + 40) + "px"'
      top='10px' lock-scroll>
      <TableEditor :tableEditorFieldInfo='powerTableEditor.tableEditorFieldInfo'
        :tableEditorContent='powerTableEditor.tableEditorContent'
        :getSpecialStringArray='powerTableEditorGetSpecialStringArray'
        :style='{ "margin-top": "-20px", height: (powerTableEditor.editFlag ? powerTableEditor.tableEditorInfo.EditHeight : powerTableEditor.tableEditorInfo.SaveHeight) + "px"}'
        :tableEditorInfo='powerTableEditor.tableEditorEditorInfo' :editFlag='powerTableEditor.editFlag'>
        <template #slot-PowerCode>
          <el-autocomplete placeholder='请输入' size='mini' v-model='powerTableEditor.tableEditorContent.PowerCode'
            :disabled='powerTableEditor.editFlag ? true : false'
            :readonly='powerTableEditor.editFlag ? true : false'
            :fetch-suggestions='powerCodeQuerySearch' @select='powerCodeSelect'
            :style='{ width: "250px"}'>
          </el-autocomplete>
        </template>
      </TableEditor>
      <div class='dialogButtomCenterBtn'>
        <el-button type='primary' @click='saveOrEditPowerTableEditor()' size='mini'>保存</el-button>
        <el-button @click='powerTableEditorReset()' size='mini'>重置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Loading } from 'element-ui'
import axiosHelper from '@/utils/axiosHelper'
import power from '@/components/sys/Power'
import code from '@/components/sys/Code'
import select from '@/components/sys/Select'
import tableEditor from '@/components/sys/TableEditor'
import TableEditor from '@/components/sys/TableEditor.vue'

export default {
  name: 'Menu',
  components: {
    TableEditor: TableEditor
  },
  metaInfo: function () {
    return {
      title: this.menuName
    }
  },
  data () {
    return {
      menuCode: '',
      menuName: '',
      menus: [],
      selectMenus: [],
      isLeafs: [],
      powers: [],
      superAdminOnlyMenus: [],
      expandRowKeys: [],
      loading: false,

      showAddMenuDialog: false,
      addMenuInfo: {
        menuCode: '',
        menuName: '',
        description: '',
        filePath: '',
        isLeaf: '0',
        menuLevel: 1,
        icon: '',
        parentMenuCode: '',
        seq: 0,
        superAdminOnlyMenu: '0',
        parameter: ''
      },

      showEditMenuDialog: false,
      editMenuRow: {},
      editMenuInfo: {
        menuCode: '',
        menuName: '',
        description: '',
        filePath: '',
        isLeaf: '0',
        menuLevel: 1,
        icon: '',
        parentMenuCode: '',
        seq: 0,
        superAdminOnlyMenu: '0',
        parameter: ''
      },

      showPowerTableEditorDialog: false,
      powerTableEditor: {
        tableEditorCode: 'SYS_Power',
        tableEditorInfo: {},
        tableEditorFieldInfo: [],
        oldTableEditorContent: {},
        tableEditorContent: {},
        editFlag: false
      },

      showAddPower: false,
      showEditPower: false,
      showDeletePower: false,

      showAddPowerPower: false,
      showEditPowerPower: false,
      showDeletePowerPower: false
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  created: async function () {
    const that = this
    that.menuCode = that.$route.path.substring(1)
    that.menuName = that.$route.meta.title
    power.setPower(that)
    const codes = that.codes
    that.isLeafs = code.getCode(codes, 'SYS_Menu_IsLeaf')
    that.powers = code.getCode(codes, 'SYS_Power')
    that.superAdminOnlyMenus = code.getCode(codes, 'SYS_Menu_SuperAdminOnlyMenu')

    const tableContentPromise = that.refreshMainTableContent()
    const menusPromise = select.getSelectData('SYS_Menu', '')

    await tableContentPromise
    that.selectMenus = await menusPromise
  },

  methods: {
    // 页面主表格深度刷新方法
    refreshMainTableContent: async function () {
      const that = this
      that.loading = true
      const rtnObj = await axiosHelper.handle('/WebSYSAction/Menu.GetAllMenus', {})
      if (rtnObj.error === '000000') {
        that.menus = rtnObj.data
      } else {
        that.$message.error(rtnObj.msg)
      }
      that.loading = false
    },

    // 获取表格高度
    getTableHeight: function () {
      return (window.innerHeight - 140) - (this.$store.state.showTabs ? 30 : 0) + 'px'
    },

    // 表格单元格样式
    mainTableCellStyle: function () {
      return { padding: '0px' }
    },

    // 表格表头单元格样式
    mainTableHeaderCellStyle: function () {
      return { padding: '5px', 'background-color': '#f5f7fa' }
    },

    // 页面主表格行样式设定方法
    mainTableRowStyle: function (data, rowIndex) {
      if (data.row.SuperAdminOnlyMenu === '1') {
        if (data.row.IsLeaf === '1') {
          if (data.row.MenuLevel === 999) {
            return { 'background-color': '#cce8cf', color: 'blue' }
          } else {
            return { 'background-color': '#cce8cf' }
          }
        } else {
          if (data.row.MenuLevel === 999) {
            return { 'background-color': '#cce8cf', 'font-weight': '800', color: 'blue' }
          } else {
            return { 'background-color': '#cce8cf', 'font-weight': '800' }
          }
        }
      } else {
        if (data.row.IsLeaf === '1') {
          if (data.row.MenuLevel === 999) {
            return { color: 'blue' }
          } else {
            return {}
          }
        } else {
          if (data.row.MenuLevel === 999) {
            return { 'font-weight': '800', color: 'blue' }
          } else {
            return { 'font-weight': '800' }
          }
        }
      }
    },

    // 新增菜单弹出框显示方法
    showAddMenuDialogMD: function (seq, parentMenuCode) {
      const that = this
      that.showAddMenuDialog = true
      that.addMenuInfo.menuLevel = seq
      that.addMenuInfo.parentMenuCode = (parentMenuCode ? (parentMenuCode + '') : '')
      that.addMenuInfoReset()
      that.addMenuInfo.menuCode = (parentMenuCode ? (parentMenuCode + '/') : '')
    },

    // 新增菜单弹出框数据重置方法
    addMenuInfoReset: function () {
      const that = this
      that.addMenuInfo.menuCode = ''
      that.addMenuInfo.menuName = ''
      that.addMenuInfo.description = ''
      that.addMenuInfo.filePath = ''
      that.addMenuInfo.isLeaf = that.addMenuInfo.menuLevel === 1 ? '0' : '1'
      that.addMenuInfo.icon = ''
      that.addMenuInfo.seq = 0
      that.addMenuInfo.superAdminOnlyMenu = '0'
      that.addMenuInfo.parameter = ''
    },

    // 新增菜单
    addMenu: async function () {
      const that = this
      if (!that.addMenuInfo.menuCode) {
        that.$message.error('请输入菜单编号！')
        return
      }
      if (!that.addMenuInfo.menuName) {
        that.$message.error('请输入菜单名称！')
        return
      }
      if (!that.addMenuInfo.seq) {
        that.$message.error('请输入菜单序号！')
        return
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebSYSAction/Menu.AddMenu', that.addMenuInfo)
      if (rtnObj.error === '000000') {
        that.showAddMenuDialog = false
        that.refreshMainTableContent()
        that.$message.success('恭喜你，新增菜单成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 修改菜单弹出框显示方法
    showEditMenuDialogMD: function (row) {
      const that = this
      that.editMenuRow = row
      that.showEditMenuDialog = true
      that.editMenuInfoReset()
    },

    // 修改菜单弹出框数据重置方法
    editMenuInfoReset: function () {
      const that = this
      that.editMenuInfo.menuCode = that.editMenuRow.MenuCode
      that.editMenuInfo.menuName = that.editMenuRow.MenuName
      that.editMenuInfo.description = that.editMenuRow.Description
      that.editMenuInfo.filePath = that.editMenuRow.FilePath
      that.editMenuInfo.isLeaf = that.editMenuRow.IsLeaf
      that.editMenuInfo.icon = that.editMenuRow.Icon
      that.editMenuInfo.seq = that.editMenuRow.Seq
      that.editMenuInfo.superAdminOnlyMenu = that.editMenuRow.SuperAdminOnlyMenu
      that.editMenuInfo.parameter = that.editMenuRow.Parameter
      that.editMenuInfo.menuLevel = that.editMenuRow.MenuLevel
      that.editMenuInfo.parentMenuCode = that.editMenuRow.ParentMenuCode
    },

    // 修改菜单
    editMenu: async function () {
      const that = this
      if (!that.editMenuInfo.menuCode) {
        that.$message.error('请输入菜单编号！')
        return
      }
      if (!that.editMenuInfo.menuName) {
        that.$message.error('请输入菜单名称！')
        return
      }
      if (!that.editMenuInfo.seq) {
        that.$message.error('请输入菜单序号！')
        return
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebSYSAction/Menu.EditMenu', that.editMenuInfo)
      if (rtnObj.error === '000000') {
        that.showEditMenuDialog = false
        that.refreshMainTableContent()
        that.$message.success('恭喜你，修改菜单成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 删除菜单确认弹出框
    showDeleteOneMenuConfirm: function (scope) {
      const that = this
      that.$confirm('此操作将永久删除该菜单【' + scope.row.MenuCode + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.deleteOneMenu(scope.row.MenuCode)
      }).catch(() => {
      })
    },

    // 删除一个菜单
    deleteOneMenu: async function (menuCode) {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebSYSAction/Menu.DeleteMenu', {
        menuCode: menuCode
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('恭喜你，删除菜单信息成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 展开行
    expandRow: function () {
      const that = this
      that.expandRowKeys = []
      for (let i = 0; i < that.menus.length; i++) {
        that.expandRowKeys.push(that.menus[i].GUID)
      }
    },

    // 折叠行
    narrowRow: function () {
      const that = this
      for (let i = 0; i < that.menus.length; i++) {
        that.$refs.mainTable.toggleRowExpansion(that.menus[i], false)
      }
    },

    // 特征字符串转换方法
    powerTableEditorGetSpecialStringArray: function (columnCode) {
      const that = this
      if (columnCode === 'MenuCode') {
        return that.selectMenus
      }
    },

    // 表格编辑器新增弹出框显示方法
    showPowerTableEditorDialogMD: async function (row) {
      const that = this
      that.powerTableEditor.editFlag = false
      await tableEditor.showTableEditor(that, 'powerTableEditor')
      that.powerTableEditor.tableEditorContent.MenuCode = row.MenuCode
      that.showPowerTableEditorDialog = true
    },

    // 表格编辑器修改弹出框显示方法
    showPowerTableEditorDialogEditMD: async function (scope) {
      const that = this
      that.powerTableEditor.oldTableEditorContent = {
        MenuCode: scope.row.ParentMenuCode,
        PowerCode: scope.row.MenuCode,
        PowerName: scope.row.MenuName,
        Description: scope.row.Description,
        TimeStamp: scope.row.TimeStamp
      }
      that.powerTableEditor.editFlag = true
      await tableEditor.showTableEditor(that, 'powerTableEditor')
      that.showPowerTableEditorDialog = true
    },

    // 表格编辑器新增修改弹出框数据重置方法
    powerTableEditorReset: function () {
      const that = this
      tableEditor.tableEditorReset(that, 'powerTableEditor')
    },

    // 表格编辑器数据新增修改
    saveOrEditPowerTableEditor: async function () {
      const that = this
      const rtnObj = await tableEditor.saveOrEditTableEditor(that, 'powerTableEditor')
      if (!rtnObj) return
      if (rtnObj.error === '000000') {
        that.$message.success(that.powerTableEditor.editFlag ? '恭喜你，变更' + that.powerTableEditor.tableEditorInfo.TableEditorName + '成功！' : '恭喜你，新增' + that.powerTableEditor.tableEditorInfo.TableEditorName + '成功！')
        that.refreshMainTableContent()
        that.showPowerTableEditorDialog = false
      } else {
        that.$message.error(rtnObj.msg)
      }
    },

    // 表格编辑器数据批量删除方法
    deletePowerTableEditor: async function (selectedTableEditorContent) {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await tableEditor.deleteTableEditor(that, 'powerTableEditor', selectedTableEditorContent)
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('恭喜你，删除' + that.powerTableEditor.tableEditorInfo.TableEditorName + '成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 表格编辑器删除某行数据确认弹出框显示方法
    deleteOnePowerTableEditor: async function (scope) {
      const that = this
      await tableEditor.showTableEditor(that, 'powerTableEditor')
      that.$confirm('此操作将永久删除该' + that.powerTableEditor.tableEditorInfo.TableEditorName + ', 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.deletePowerTableEditor([{
          MenuCode: scope.row.ParentMenuCode,
          PowerCode: scope.row.MenuCode,
          PowerName: scope.row.MenuName,
          Description: scope.row.Description,
          TimeStamp: scope.row.TimeStamp
        }])
      }).catch(() => {
      })
    },

    // 表格编辑器批量删除确认弹出框显示方法
    batchDeletePowerTableEditor: async function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      await tableEditor.showTableEditor(that, 'powerTableEditor')
      that.$confirm('此操作将永久删除该' + that.powerTableEditor.tableEditorInfo.TableEditorName + ', 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.deletePowerTableEditor(that.mainTable.selections)
      }).catch(() => {
      })
    },

    // 新增修改权限时权限输入建议查询方法
    powerCodeQuerySearch: function (queryString, cb) {
      const that = this
      const results = []
      for (let i = 0; i < that.powers.length; i++) {
        if (that.powers[i].code.toUpperCase().indexOf(queryString.toUpperCase()) >= 0) {
          results.push({ value: that.powers[i].code, name: that.powers[i].name })
        }
      }
      cb(results)
    },

    // 新增修改权限时权限编号选择方法
    powerCodeSelect: function (item) {
      const that = this
      that.powerTableEditor.tableEditorContent.PowerName = item.name
    }
  }
}
</script>

<style scoped>
.navbar {
  padding-bottom: 0px;
  width: 100%;
  padding: 0;
  margin-bottom: 5px;
  margin-top: -10px;
}
.hbox {
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.formRow {
  margin-top: 2px;
  margin-bottom: 3px;
}
.dialogButtomBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.dialogButtomCenterBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
</style>
